/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_search_tools__messages__error = /** @type {(inputs: {}) => string} */ () => {
	return `Es ist ein Fehler aufgetreten.`
};

const en_search_tools__messages__error = /** @type {(inputs: {}) => string} */ () => {
	return `An error occurred.`
};

const es_search_tools__messages__error = /** @type {(inputs: {}) => string} */ () => {
	return `Se ha producido un error.`
};

const fr_search_tools__messages__error = /** @type {(inputs: {}) => string} */ () => {
	return `Il y a eu une erreur.`
};

const it_search_tools__messages__error = /** @type {(inputs: {}) => string} */ () => {
	return `C'è stato un errore.`
};

const nl_search_tools__messages__error = /** @type {(inputs: {}) => string} */ () => {
	return `Er was een fout.`
};

const pt_search_tools__messages__error = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_tools__messages__error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_tools__messages__error", locale)
	if (locale === "de") return de_search_tools__messages__error(inputs)
	if (locale === "en") return en_search_tools__messages__error(inputs)
	if (locale === "es") return es_search_tools__messages__error(inputs)
	if (locale === "fr") return fr_search_tools__messages__error(inputs)
	if (locale === "it") return it_search_tools__messages__error(inputs)
	if (locale === "nl") return nl_search_tools__messages__error(inputs)
	return pt_search_tools__messages__error(inputs)
};